import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";

const useAddStaff = ({ staffInfo = {}, isEditable = false, currentItem = {} }) => {
  const [isAddStaffLoading, setIsAddStaffLoading] = useState(false);

  const validateStaffInfo = (info) => {
    if (!info.staffName) return "Staff name is required";
    if (!info.mobileNumber) return "Mobile number is required";
    if (!info.username) return "Username is required";
    if (!isEditable && !info.password) return "Password is required";
    if (!isEditable && info.password !== info.confirmPassword) return "Passwords do not match";
    if (!info.headId) return "Doctor selection is required";
    return null;
  };

  const onAddNewStaff = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const validationError = validateStaffInfo(staffInfo);
    if (validationError) {
      toast.error(validationError);
      return;
    }

    setIsAddStaffLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const requestData = {
        username: staffInfo.username,
        userType: "ASSISTANT",
        name: staffInfo.staffName,
        email: staffInfo.email,
        mobileNumber: staffInfo.mobileNumber,
        photo: staffInfo.photo,
        age: staffInfo.age,
        headId: staffInfo.headId,
      };

      // Only include password in request if it's provided (for new staff or password updates)
      if (staffInfo.password) {
        requestData.password = staffInfo.password;
      }

      const response = await axios({
        method: isEditable ? 'patch' : 'post',
        url: `/api/v1/users${isEditable ? `/${currentItem.id}` : ''}`,
        data: requestData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data) {
        toast.success(isEditable ? "Staff updated successfully" : "Staff added successfully");
        return response.data;
      }
    } catch (error) {
      console.error("Error with staff:", error.response?.data?.message);
      const errorMessage = error.response?.data?.message[0] || `Error ${isEditable ? 'updating' : 'adding'} staff`;
      toast.error(errorMessage);
      throw error;
    } finally {
      setIsAddStaffLoading(false);
    }
  };

  return {
    isAddStaffLoading,
    onAddNewStaff,
  };
};

export default useAddStaff; 